import { memo, useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import CopyrightSharpIcon from '@mui/icons-material/CopyrightSharp';
import { designTokens } from '@design-system';

const CopyRight = memo(function CopyRight() {
  const currentYear = useMemo(() => new Date().getFullYear(), []);

  return (
    <Box sx={{ display: 'flex' }}>
      <CopyrightSharpIcon
        sx={{
          width: '10px',
          color: designTokens.colors.neutral[500],
          pr: '1px',
          height: '15px',
        }}
        fontSize="small"
      />
      <Box>
        <Typography
          sx={{
            color: designTokens.colors.neutral[500],
            fontSize: '0.625rem',
            fontFamily: designTokens.typography.fontFamily.primary,
            fontWeight: 400,
          }}
        >
          {currentYear} Family Food Centre. All rights reserved.
        </Typography>
        <Typography
          sx={{
            color: designTokens.colors.neutral[500],
            fontSize: '0.625rem',
            ml: -1,
            fontFamily: designTokens.typography.fontFamily.primary,
            fontWeight: 400,
          }}
        >
          Version: {__APP_VERSION__}
        </Typography>
      </Box>
    </Box>
  );
});

CopyRight.displayName = 'CopyRight';

export default CopyRight;
